type Kebab<
  T extends string,
  A extends string = "",
> = T extends `${infer F}${infer R}`
  ? Kebab<R, `${A}${F extends Lowercase<F> ? "" : "-"}${Lowercase<F>}`>
  : A;
type KebabKeys<T> = { [K in keyof T as K extends string ? Kebab<K> : K]: T[K] };

type CSSStyle = {
  [K in keyof KebabKeys<CSSStyleDeclaration>]?: string | number;
};

const style = (cssStyle: CSSStyle) => {
  return Object.entries(cssStyle)
    .map(([property, value]) => `${property}:${value};`)
    .join(" ");
};

export function txLog(
  msg:
    | string
    | { msg: string; msgStyle?: CSSStyle; tag?: string; tagStyle?: CSSStyle },
  ...args: any[]
): void {
  if (typeof window === "undefined") {
    return;
  }

  const {
    msg: message,
    msgStyle,
    tag,
    tagStyle,
  } = typeof msg === "string" ? { msg } : msg;

  let logString = "%c %ctx-core%c";

  const styles = [
    'padding-left: 18px; line-height: 20px; background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSIjMDAwIiBzdHJva2U9IiNGRkYiIHN0cm9rZS13aWR0aD0iMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIj48cGF0aCBkPSJNNCA3VjRoMTZ2MyIvPjxwYXRoIGQ9Ik01IDIwaDYiLz48cGF0aCBkPSJNMTMgNCA4IDIwIi8+PHBhdGggZD0ibTE1IDE1IDUgNSIvPjxwYXRoIGQ9Im0yMCAxNS01IDUiLz48L3N2Zz4="); background-size: 16px; background-repeat: no-repeat; background-position: 2px 2px',
    "background: #229; border-radius:0.5em 0.0em 0.0em 0.5em; padding:0.2em 0.5em 0.1em 0.5em; color: white; font-weight: bold;",
    "",
  ];

  if (tag) {
    logString += `%c${tag}%c`;
    styles.push(
      tagStyle
        ? style(tagStyle)
        : "background: #33F; border-radius:0.0em 0.5em 0.5em 0.0em; padding:0.2em 0.5em 0.1em 0.5em; color: white;",
      "",
    );
  }

  window.console.groupCollapsed(
    `${logString} %c${message}`,
    ...styles,
    msgStyle
      ? style(msgStyle)
      : "background: #55F; border-radius:0.5em; padding:0.2em 0.5em 0.1em 0.5em; color: white;",
    "",
  );
  for (const arg of args) {
    window.console.info(arg);
  }
  window.console.groupEnd();
}
